var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { SkeletonAvatar } from './Avatar';
import { SkeletonButton } from './Button';
import { SkeletonInput } from './Input';
import { SkeletonImage } from './Image';
import { SkeletonParagraph } from './Paragraph';
import { SkeletonTitle } from './Title';
var Skeleton = /** @class */ (function (_super) {
    __extends(Skeleton, _super);
    function Skeleton(props) {
        var _this = _super.call(this, props) || this;
        _this.getParagraphProps = function (paragraph) {
            var active = _this.props.active;
            var paragraphProps = { active: active, width: 448, rows: 4 };
            if (paragraph && typeof paragraph === 'object') {
                paragraphProps.active = active;
                paragraphProps.width = paragraph.width || 448;
                paragraphProps.rows =
                    paragraph.rows === undefined || paragraph.rows === null || paragraph.rows < 0
                        ? 4
                        : paragraph.rows;
            }
            return paragraphProps;
        };
        _this.getAvatarProps = function (avatar) {
            var active = _this.props.active;
            var avatarProps = { active: active, shape: 'circle', style: {}, className: '' };
            if (avatar && typeof avatar === 'object') {
                avatarProps.active = active;
                avatarProps.shape = avatar.shape || 'circle';
            }
            return avatarProps;
        };
        _this.getTitleProps = function (title) {
            var active = _this.props.active;
            var titleProps = { active: active, width: undefined };
            if (title && typeof title === 'object') {
                titleProps.active = active;
                titleProps.width = title.width || undefined;
            }
            return titleProps;
        };
        _this.renderSkeleton = function () {
            var _a = _this.props, loading = _a.loading, children = _a.children, avatar = _a.avatar, paragraph = _a.paragraph, title = _a.title;
            if (loading || loading === undefined) {
                var headerNode = void 0;
                if (title || avatar) {
                    // title
                    var titleNode = void 0;
                    if (title) {
                        var titleProps = _this.getTitleProps(title);
                        titleNode = React.createElement(SkeletonTitle, __assign({}, titleProps));
                    }
                    var avatarNode = void 0;
                    if (avatar) {
                        var avatarProps = _this.getAvatarProps(avatar);
                        avatarNode = React.createElement(SkeletonAvatar, __assign({}, avatarProps));
                    }
                    headerNode = (React.createElement(DivTag, { className: title && avatar ? 'both' : '', autoPrefixedClassName: "skeleton-header" },
                        avatarNode,
                        titleNode));
                }
                var bodyNode = void 0;
                if (paragraph) {
                    var paragraphProps = _this.getParagraphProps(paragraph);
                    bodyNode = React.createElement(SkeletonParagraph, __assign({}, paragraphProps));
                }
                return (React.createElement(React.Fragment, null,
                    headerNode,
                    React.createElement(DivTag, { autoPrefixedClassName: "skeleton-content" }, bodyNode)));
            }
            else {
                return children;
            }
        };
        _this.state = {};
        return _this;
    }
    Skeleton.prototype.render = function () {
        var _a = this.props, active = _a.active, loading = _a.loading, children = _a.children, avatar = _a.avatar, paragraph = _a.paragraph, title = _a.title, rest = __rest(_a, ["active", "loading", "children", "avatar", "paragraph", "title"]);
        var renderSkeleton = this.renderSkeleton();
        return (React.createElement(DivTag, __assign({ name: Skeleton.NAME }, rest), renderSkeleton));
    };
    Skeleton.defaultProps = defaultProps;
    Skeleton.NAME = 'skeleton';
    Skeleton.displayName = 'Skeleton';
    return Skeleton;
}(Component));
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Button = SkeletonButton;
Skeleton.Input = SkeletonInput;
Skeleton.Image = SkeletonImage;
export default Skeleton;
